import { HeaderButton } from "./styles";
import { OrderTabsWrapper } from "./styles";

interface IOrderTabs {
	activeItem: number | "";
	handleChangeCallback: any;
}

export const OrderTabs: React.FC<IOrderTabs> = ({
	activeItem,
	handleChangeCallback,
}) => {
	return (
		<OrderTabsWrapper>
			<HeaderButton
				name=""
				onClick={handleChangeCallback}
				className={activeItem === "" ? "active" : ""}
			>
				<span>Todos</span>
				<span className="hide-on-sm">&nbsp;os&nbsp;pedidos</span>
			</HeaderButton>
			{/*  */}
			<HeaderButton
				name="1"
				onClick={handleChangeCallback}
				className={activeItem == 1 ? "active" : ""}
			>
				Abertos
			</HeaderButton>
			{/*  */}

			<HeaderButton
				name="2"
				onClick={handleChangeCallback}
				className={activeItem == 2 ? "active" : ""}
			>
				Processando
			</HeaderButton>
			{/*  */}
			<HeaderButton
				name="4"
				onClick={handleChangeCallback}
				className={activeItem == 4 ? "active" : ""}
			>
				Concluídos
			</HeaderButton>
			{/*  */}
			<HeaderButton
				name="3"
				onClick={handleChangeCallback}
				className={activeItem == 3 ? "active" : ""}
			>
				Cancelados
			</HeaderButton>
		</OrderTabsWrapper>
	);
};
